import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { BreadcrumbRow, BreadcrumbText, BreadcrumbWrapper, } from './Breadcrumb.styles';
import BreadcrumbItem from './models/breadcrumb-item.entity';

const Breadcrumb = () => {
  const location = useLocation();
  const history = useHistory();
  const currentPath = location.pathname.startsWith('/')
    ? location.pathname
    : `/${location.pathname}`;

  const items: BreadcrumbItem[] = [
    {
      text: 'Tipo do veículo',
      href: '/inspection-type',
      disabled: false,
      active: false,
    },
    {
      text: 'Dados do veículo',
      href: '/plate-confirmation',
      matchPaths: ['/vehicle-identifier'],
      disabled: false,
      active: false,
    },
    {
      text: 'Dados pessoais',
      href: '/inspection',
      disabled: false,
      active: false,
    },
    {
      text: 'Resumo da compra',
      href: '/summary',
      disabled: false,
      active: false,
    },
    {
      text: 'Pagamento',
      href: '/payment',
      disabled: false,
      active: false,
    },
  ];

  const getActiveItem = (): number => {
    let index = items
      .findIndex((item) => currentPath === item.href || !!item.matchPaths?.includes(currentPath));

    if (index === -1) {
      index = items
        .findIndex((item) => currentPath.includes(item.href));
    }

    return index;
  }

  const atualIndex: number = getActiveItem();

  const onClickItem = (path: string) => {
    history.push(path);
  }

  return (
    <BreadcrumbWrapper>
      {items && items.map((item, index) => {
        return (
          <BreadcrumbRow key={index}>
            <BreadcrumbText
              active={index === atualIndex}
              clickable={index < atualIndex}
              onClick={() => (index < atualIndex) ? onClickItem(item.href) : void (0)}
            >
              {item.text}
            </BreadcrumbText>
            {(index + 1) < items.length ? <ChevronRightIcon /> : <></>}
          </BreadcrumbRow>
        );
      })}
    </BreadcrumbWrapper>
  );
};

export default Breadcrumb;
